module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "commentManage"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("评论管理")]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.queryParam
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "110px"
    },
    model: {
      value: (_vm.queryParam.searchType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchType", $$v)
      },
      expression: "queryParam.searchType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "评论ID",
      "value": "commentId"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "评论内容",
      "value": "contentLike"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "placeholder": _vm.searchPlaceholder,
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.clickSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParam.searchValue),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "searchValue", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "queryParam.searchValue"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.contentAuditStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "contentAuditStatus", $$v)
      },
      expression: "queryParam.contentAuditStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审核中",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "通过",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未通过",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": -1
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.clickReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSearch
    }
  }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "status-tabs"
  }, _vm._l((_vm.statusTabs), function(item) {
    return _c('el-button', {
      key: item.value,
      class: [
        'status-tab-btn',
        {
          'is-active': _vm.queryParam.contentAuditStatus === item.value
        } ],
      on: {
        "click": function($event) {
          return _vm.changeAuditStatus(item.value)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item.label) + "\n    ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "com-list"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.listData,
      "border": ""
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "评论ID",
      "min-width": "100",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "评论内容",
      "min-width": "220",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.content || "--"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发布时间",
      "min-width": "170",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.publishTimeText))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户信息",
      "min-width": "150",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.routeDynamicDetail(row)
            }
          }
        }, [_vm._v("\n              " + _vm._s(row.uid) + "\n            ")])], 1), _vm._v(" "), _c('div', [_vm._v("昵称：" + _vm._s(row.nickName || "--"))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "postId",
      "label": "所属动态ID",
      "min-width": "120",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "审核状态",
      "min-width": "95",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.contentAuditStatusText))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "驳回原因",
      "min-width": "180",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.reasonText))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "95",
      "align": "center",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openSingleAudit(row)
            }
          }
        }, [_vm._v("审核")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.selectedRows.length === 0
    },
    on: {
      "click": _vm.openBatchAuditDialog
    }
  }, [_vm._v("批量审核")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginationVirtualTotal > 0),
      expression: "paginationVirtualTotal > 0"
    }],
    staticClass: "pagination-seq"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, next",
      "current-page": _vm.queryParam.pageNum,
      "page-size": _vm.queryParam.pageSize,
      "total": _vm.paginationVirtualTotal
    },
    on: {
      "current-change": _vm.changeCurrentPage
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pagination-seq-hint"
  }, [_vm._v("第 " + _vm._s(_vm.queryParam.pageNum) + " 页")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "评论审核",
      "size": "tiny",
      "modal-append-to-body": false
    },
    model: {
      value: (_vm.auditDialog.visible),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "visible", $$v)
      },
      expression: "auditDialog.visible"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "86px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    on: {
      "change": _vm.onAuditStatusChange
    },
    model: {
      value: (_vm.auditDialog.contentAuditStatus),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "contentAuditStatus", $$v)
      },
      expression: "auditDialog.contentAuditStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "通过",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未通过",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), (_vm.auditDialog.contentAuditStatus === 2) ? _c('el-form-item', {
    attrs: {
      "label": "驳回原因"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "请选择事由类型（可选）"
    },
    on: {
      "change": _vm.onReasonPresetChange
    },
    model: {
      value: (_vm.auditDialog.reasonPresetKey),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "reasonPresetKey", $$v)
      },
      expression: "auditDialog.reasonPresetKey"
    }
  }, _vm._l((_vm.reasonPresetOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1), _vm._v(" "), (_vm.auditDialog.reasonPresetKey === _vm.reasonPresetOtherKey) ? _c('el-input', {
    staticClass: "reason-extra-input",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "maxlength": 50,
      "placeholder": "请输入驳回原因（最多50字）",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.auditDialog.reasonExtra),
      callback: function($$v) {
        _vm.$set(_vm.auditDialog, "reasonExtra", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "auditDialog.reasonExtra"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-tip"
  }, [_vm._v("\n      人工审核不通过时，APP 端该条评论删除，后台仍保留记录。\n    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.auditDialog.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAudit
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-08abf79f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/comment/commentManage.vue
// module id = 933
// module chunks = 0